import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-[1040px]" }
const _hoisted_2 = {
  key: 0,
  class: "space-y-4 border-t border-gray-100 pt-5"
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "flex" }

import { XCircleIcon } from '@heroicons/vue/24/outline'
import { computed, inject, onMounted, ref } from 'vue'
import { useStore } from 'vuex'

import InputField from '@/components/neue/InputField'
import NeueButton from '@/components/neue/NeueButton'
import NeueLoading from '@/components/neue/NeueLoading'
import SelectInput from '@/components/neue/SelectInput'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import australiaStates from '@/models/australiaStates'
import canadianStates from '@/models/canadianStates'
import unitedKingdomStates from '@/models/unitedKingdomStates'
import usaStates from '@/models/usaStates'
import api from '@/store/api'
import { mapRelationship, mapType } from '@/store/mappers'


export default {
  __name: 'StoreTaxes',
  props: ['id'],
  setup(__props) {

const bus = inject('bus')
const loading = ref(true)
const props = __props
const vuexStore = useStore()
const store = computed(() => mapRelationship({ type: 'store', id: props.id }))
const allStates = computed(() =>
  ({ USA: usaStates, AUS: australiaStates, CAN: canadianStates, GBR: unitedKingdomStates })[
    vuexStore.getters.country
  ]?.map(x => ({
    name: x.label,
    value: x.value
  }))
)
const stateName = state => allStates.value.find(x => x.value === state)?.name ?? state

const modules = ref([])

const addingState = ref(null)
const structure = ref('none')

onMounted(() =>
  Promise.all([
    api.call('GET', `stores/${props.id}?included=attachments`).then(() => {
      structure.value = store.value.attributes.tax_structure
    }),
    api.call('GET', 'tax_modules').then(discardModules)
  ]).then(() => {
    loading.value = false
  })
)

const addModule = async () => {
  await api.call('POST', 'tax_modules', {
    tax_module: {
      state_code: addingState.value
    }
  })
  addingState.value = null
  discardModules()
}

const deleteModule = async mod => {
  await api.call('DELETE', `tax_modules/${mod.id}`)
  discardModules()
}

const dirty = () => bus.emit('dirty/store', { from: 'taxes' })

bus.on('save/store', () => {
  api.call('PUT', `stores/${props.id}?included=none`, {
    store: {
      tax_structure: structure.value
    }
  })
  for (const mod of modules.value.filter(x => x.dirty)) {
    api.call('PUT', `tax_modules/${mod.id}`, {
      tax_module: {
        tax_rate: mod.value
      }
    })
    mod.dirty = false
  }
})

const discardModules = () => {
  modules.value = mapType('tax_module')
    .map(x => ({
      id: x.id,
      state: x.attributes.state_code,
      value: x.attributes.tax_rate,
      dirty: false
    }))
    .sort((a, b) => stateName(a.state).localeCompare(stateName(b.state)))
}

bus.on('discard/store', () => {
  structure.value = store.value.attributes.tax_structure
  discardModules()
})

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(NeueLoading), { loading: loading.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SettingsSection, {
          title: "Tax structure",
          description: "Manual lets you set a percentage per state yourself. TaxJar works it out for you from the item type and the jurisdictions an order moves between - for that, every fulfillment method needs an address so nexus can be determined."
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SelectInput), {
              modelValue: structure.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((structure).value = $event)),
              name: "Tax structure",
              options: [
            { name: 'None', value: 'none' },
            { name: 'Manual', value: 'manual' },
            { name: 'TaxJar', value: 'taxjar' }
          ],
              onInput: dirty
            }, null, 8, ["modelValue"]),
            (structure.value === 'manual')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modules.value, (mod) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: mod.state,
                      class: "flex items-center justify-between w-full"
                    }, [
                      _createTextVNode(_toDisplayString(stateName(mod.state)) + " ", 1),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_unref(InputField), {
                          modelValue: mod.value,
                          "onUpdate:modelValue": $event => ((mod.value) = $event),
                          class: "w-32",
                          suffix: "%",
                          onInput: 
                  () => {
                    dirty()
                    mod.dirty = true
                  }
                
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"]),
                        _createVNode(_unref(XCircleIcon), {
                          class: "h-[1.4rem] w-[1.4rem] ml-12 cursor-pointer text-gray-700 flex-shrink-0",
                          onClick: $event => (deleteModule(mod))
                        }, null, 8, ["onClick"])
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(SelectInput), {
                      modelValue: addingState.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((addingState).value = $event)),
                      class: "flex-grow",
                      placeholder: "Choose a state",
                      options: allStates.value.filter(x => !modules.value.some(y => y.state === x.value)),
                      onKeydown: _withKeys(addModule, ["enter"])
                    }, null, 8, ["modelValue", "options"]),
                    _createVNode(_unref(NeueButton), {
                      class: "ml-4",
                      type: addingState.value ? 'secondary' : 'inactive',
                      onClick: addModule
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode(" + State ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["type"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

}